export function resolveBrand() {
	const { hostname, pathname } = window.location;

	const host = hostname.toLowerCase();

	// Handle production domains
	if (host.includes("adista")) return "ADISTA";
	if (host.includes("terrenova")) return "TERRENOVA";

	// Local dev
	const path = pathname.toLowerCase();
	if (path.startsWith("/adista")) return "ADISTA";
	if (path.startsWith("/terrenova")) return "TERRENOVA";

	return "OPTIVIEW";
}
